import type { FlexProps } from "@qws-org/ui-kit";
import type { FC } from "react";

import type { Action, CardGallery as CardGalleryData, Pages } from "~/core";
import type { ImageParams } from "~/shared/utils/directus/useDirectus";

import { Column } from "./components/Column";
import { Row } from "./components/Row";

export type CardGalleryProps = {
  data: CardGalleryData;
  getUrl: (page: Pages) => string;
  onCallAction: (action: Action) => void;
  isControlInactive: (control: Action) => boolean;
  getImageUrl: (imageId: string, params?: ImageParams) => string;
} & FlexProps;
export const CardGallery: FC<CardGalleryProps> = (props) => {
  const { data } = props;

  return (
    <>{data.variant === "row" ? <Row {...props} /> : <Column {...props} />}</>
  );
};
